export default "__VITE_ASSET__CrEYpq5A__"